/* eslint-disable react/display-name, react/destructuring-assignment */
import { createElement, startTransition } from "react"
import type { FC, ReactElement } from "react"

import { useBoolean, useEffectOnce, useUnmount } from "react-use"

import { ESpinnerSize, Spinner } from "@/3514/components"

import { useCoachingChatDispatcher as useChatDispatcher } from "../store"
import { coachingChatStyles as classes } from "../styles"
import type { TCoachingChatConfig as TChatConfig } from "../types"

type TProps = {
    config: TChatConfig
}

function initiatedGuard(Entity: FC<TProps>): FC {
    return (props: TProps): ReactElement | null => {
        const [isStateLoaded, setIsStateLoaded]: ReturnType<typeof useBoolean> = useBoolean(false)

        const dispatcher: ReturnType<typeof useChatDispatcher> = useChatDispatcher(props.config.id)

        useEffectOnce((): void => {
            dispatcher.init()
            startTransition((): void => {
                setIsStateLoaded(true)
                props.config.onReady?.()
            })
        })

        useUnmount((): void => {
            setIsStateLoaded(false)
        })

        return isStateLoaded
            ? createElement(Entity, props)
            : createElement(Spinner, {
                  size: ESpinnerSize.Medium,
                  wrapperClassName: classes.entity.spinner({ mode: props.config.mode })
              })
    }
}

export { initiatedGuard as withCoachingChatEntityInitiatedGuard }
